module.exports = __webpack_public_path__ + "img/icon-search.36dd0183.svg";